import React from 'react'
import { getCookie, setCookie } from '@hlj/hlj-utils'
import {
  PUBLISH_MEAL_PATH_A,
  PUBLISH_SET_MEAL_INNER,
  STORE_PUBLISH_MEAL_PATH_A
} from '@constant'
import BaseStore from 'hljd/esm/SearchBar/store'
import { BEFORE_PUBLISH_MEAL_INFO } from '../constant'
import Api from '@api/shou_xie/setMeal'
import { ExclamationCircleFilled } from '@ant-design/icons'
import { message, Modal } from 'hljd'
import styles from './index.module.less'
import API from '@api/bi_nuo'
import { appendUrlQuery } from '@core/utils'
import {
  getMerchantInfo,
  goToPubMeal,
  isStoreAccount,
  isStoreHidden,
  statistic
} from '@util'
import { isWeddingRingJewelryProperty } from '@merchant-backend/util'

export default class CommonStore extends BaseStore {
  //普通套餐编辑
  setMealEditFn = (record, isDraft = false) => () => {
    if (!isDraft) {
      if (record.is_trendy == '1' && record.allow_edit != '1') {
        return Modal.info({
          title: '该套餐已报名潮婚节，无法进行编辑操作'
        })
      }

      if (record.is_in_brand) {
        return Modal.info({
          title: `${
            isWeddingRingJewelryProperty() ? '商品' : '套餐'
          }在品牌页中不可编辑`
        })
      }
      let msg = isStoreHidden()
      if (msg != 'success') {
        message.error(msg)
      } else {
        this.getEditSession(record)
      }
    } else {
      this.getEditSession(record, isDraft)
    }
  }

  getEditSession = async (record, isDraft = false) => {
    const id = record.id
    const second_category_id =
      record.second_category_id ||
      (record.secondCategory && record.secondCategory.id)
    const property_id = record.property_id || record.propertyId
    const { data, success } = await (isDraft
      ? Api.editDraftApi({ id })
      : Api.editApi(id))
    if (success) {
      sessionStorage.setItem(
        'mySetmeal_tabLength',
        JSON.stringify(data.merchandise_params || data.merchandiseParams)
      )
      let url = `${PUBLISH_MEAL_PATH_A}/${id}`
      // 加盟店账号，路径不同，并且需要加 propertyId
      if (isStoreAccount()) {
        url = `${STORE_PUBLISH_MEAL_PATH_A}/${id}?propertyId=${property_id}`
      }
      if (second_category_id && property_id == 6) {
        url += `?weddingPhotoType=${second_category_id}`
      }
      if (isDraft) {
        url = appendUrlQuery(url, { type: 'draft' })
      }
      window.location.href = url
    }
  }

  showModalFn = (id, sold, flag, is_in_brand, is_trendy) => () => {
    if (is_trendy == '1') {
      return Modal.info({
        title: '该套餐已报名潮婚节，无法进行下架操作'
      })
    }

    if (is_in_brand) {
      return Modal.info({
        title: `${
          isWeddingRingJewelryProperty() ? '商品' : '套餐'
        }在品牌页中不可编辑`
      })
    }

    let msg = isStoreHidden()
    if (sold !== 'del' && msg != 'success') {
      message.error(msg)
      return false
    }

    let that = this
    Modal.confirm({
      icon: <ExclamationCircleFilled style={{ color: '#ffbf00' }} />,
      title:
        sold == 'del'
          ? '确认要删除该套餐吗'
          : sold == true
            ? '确认要上架吗'
            : '确认要下架吗',
      onOk() {
        if (sold == 'del') {
          that.deleteSetMealFn(id, flag)
        } else {
          that.soldOutFn(id, sold, flag)
        }
      }
    })
  }

  //删除普通套餐
  async deleteSetMealFn(id, flag) {
    const { success } = await Api.deleteSetMeal({ id })
    if (success) {
      if (flag == 1) {
        this.$getList(1)
      } else {
        window.location.reload()
      }
    }
  }

  //普通套餐上下架
  async soldOutFn(id, sold, flag) {
    let params = {
      id,
      sold_out: sold == true ? 0 : 1
    }
    const { success } = await Api.SoldOut(params)
    if (success) {
      if (flag == 1) {
        // 处理页数
        const { current, pageSize } = this.$pagination
        let page = current
        if (page > 1 && this.$list.length % pageSize === 1) {
          page = current - 1
        }
        this.$getList(page)
      } else {
        window.location.reload()
      }
    }
  }

  toAddExample = id => () => {
    setCookie('hadAddClickMealRelateExample', 1, 180)
    window.location.href = `#/localMerchant/setMeal/relatedCases/${id}`
  }

  publishFn = () => {
    statistic(PUBLISH_SET_MEAL_INNER)

    // 是否店铺被禁
    let msg = isStoreHidden()
    if (msg != 'success') {
      message.error(msg)
      return false
    }
    // 是否为第一次发布套餐
    const { has_group_set, property_id, id } = getMerchantInfo() //has_group_set：false为未第一次发布
    const cookieName = id + '@@hasSetPublishMeal'
    const hasSetPublishMeal = getCookie(cookieName) || '0'
    if (!has_group_set && !Number(hasSetPublishMeal)) {
      Modal.info({
        title: `发布${
          isWeddingRingJewelryProperty() ? '商品' : '套餐'
        }前请先准备好以下材料并了解审核时间规则`,
        className: styles.send_meal_modal,
        maskClosable: true,
        width: 480,
        icon: <ExclamationCircleFilled style={{ color: '#FAAD14' }} />,
        content: (
          <ul>
            {(
              BEFORE_PUBLISH_MEAL_INFO[property_id] ||
              BEFORE_PUBLISH_MEAL_INFO['others']
            ).map((item, index) => {
              return (
                <li key={index}>
                  <h4>{item.title}</h4>
                  <p>{item.content}</p>
                </li>
              )
            })}
          </ul>
        ),
        onOk: async () => {
          const { success } = await API.changeRecordRelease()
          if (success) {
            // 此时getMerchantInfo()并未更新，暂通过本地缓存存储状态
            setCookie(cookieName, '1', 3)
          }
          goToPubMeal()
        }
      })
    } else {
      goToPubMeal()
    }
  }
}
